import { LinkfluenceAPI } from "@linkfluence/api";
import { getApiHost } from "@linkfluence/konf";
import { App } from "@linkfluence/models/app";

export class RadarlyAPI extends LinkfluenceAPI {
  public constructor() {
    super({
      endpoint: getApiHost(App.Radarly) + "/3.0",
    });
  }
}
